module.exports = __webpack_public_path__ + "static/media/ECDC_Menu.387cbdfd.svg";